import withGoogleMapApi from './withGoogleMapApi';

export {
	withGoogleMapApi
}
